import { getContentSortingOptions } from 'common/designer-modules/siteDesigner';

import {
   LIBRARY_OPTIONS_FILTER_VALUE,
   LIBRARY_OPTIONS_SORTING_VALUE,
   LIBRARY_OPTIONS_SEARCH_VALUE,
   LIBRARY_OPTIONS_CONTENT_TAGS_VALUE,
   LIBRARY_OPTIONS_CONTENT_COUNT_VALUE,
   ALL_COLLECTION_VALUE,
   SELECTED_ITEM_COLLECTION_VALUE,
   SELECTED_BY_TAGS_COLLECTION_VALUE,
   SELECTED_BY_COLLECTIONS_COLLECTION_VALUE,
   SELECTED_BY_MODEL_COLLECTION_VALUE,
   SELECTED_BY_CATEGORIES_COLLECTION_VALUE,
   SELECTED_BY_TYPES_COLLECTION_VALUE,
} from 'admin/views/site-designer/modules/content-data';


const VIDEO_COLLECTION_OPTIONS = [
   { title: 'All videos', value: ALL_COLLECTION_VALUE },
   { title: 'Selected videos', value: SELECTED_ITEM_COLLECTION_VALUE },
   { title: 'Videos with certain tags', value: SELECTED_BY_TAGS_COLLECTION_VALUE },
   { title: 'Videos from certain collections', value: SELECTED_BY_COLLECTIONS_COLLECTION_VALUE },
   { title: 'Videos of certain models', value: SELECTED_BY_MODEL_COLLECTION_VALUE },
];
const RECORD_STREAM_COLLECTION_OPTIONS = [
   { title: 'All recorded streams', value: ALL_COLLECTION_VALUE },
   { title: 'Selected recorded streams', value: SELECTED_ITEM_COLLECTION_VALUE },
   { title: 'Recorded streams with certain tags', value: SELECTED_BY_TAGS_COLLECTION_VALUE },
   { title: 'Recorded streams from certain collections', value: SELECTED_BY_COLLECTIONS_COLLECTION_VALUE },
   { title: 'Recorded streams of certain models', value: SELECTED_BY_MODEL_COLLECTION_VALUE },
];
const PHOTOSETS_COLLECTION_OPTIONS = [
   { title: 'All photosets', value: ALL_COLLECTION_VALUE },
   { title: 'Selected photosets', value: SELECTED_ITEM_COLLECTION_VALUE },
   { title: 'Photosets with certain tags', value: SELECTED_BY_TAGS_COLLECTION_VALUE },
   { title: 'Photosets from certain collections', value: SELECTED_BY_COLLECTIONS_COLLECTION_VALUE },
   { title: 'Photosets of certain models', value: SELECTED_BY_MODEL_COLLECTION_VALUE },
];
const STORE_COLLECTION_OPTIONS = [
   { title: 'All store', value: ALL_COLLECTION_VALUE },
   { title: 'Selected items', value: SELECTED_ITEM_COLLECTION_VALUE },
   { title: 'Selected types', value: SELECTED_BY_TYPES_COLLECTION_VALUE },
   { title: 'Selected categories', value: SELECTED_BY_CATEGORIES_COLLECTION_VALUE },
];
const STORIES_COLLECTION_OPTIONS = [
   { title: 'All stories', value: ALL_COLLECTION_VALUE },
   { title: 'Selected stories', value: SELECTED_ITEM_COLLECTION_VALUE },
];

const LIBRARY_OPTIONS_FILTER = { title: 'Filter', value: LIBRARY_OPTIONS_FILTER_VALUE };
const LIBRARY_OPTIONS_SORTING = { title: 'Sorting', value: LIBRARY_OPTIONS_SORTING_VALUE };
const LIBRARY_OPTIONS_SEARCH = { title: 'Search', value: LIBRARY_OPTIONS_SEARCH_VALUE };
const LIBRARY_OPTIONS_CONTENT_TAGS = { title: 'Content tags', value: LIBRARY_OPTIONS_CONTENT_TAGS_VALUE };
const LIBRARY_OPTIONS_CONTENT_COUNT = { title: 'Content count', value: LIBRARY_OPTIONS_CONTENT_COUNT_VALUE };


const TITLE =  {
   type: 'input',
   name: 'title',
   title: 'Section title',
   limit: 50,
   inputProps: {
      type: 'text',
      placeholder: 'Enter a title',
      descriptionPosition: 'right',
   },
   loadingComponentHeight: '113px',
};
const DESCRIPTION =  {
   type: 'editor',
   name: 'description',
   title: 'Description',
   inputProps: {
      placeholder: 'Enter a description...',
      limit: 100,
   },
   loadingComponentHeight: '273px',
};

const ALIGMENT =  {
   type: 'alignment',
   name: 'alignment',
   title: 'Title and description alignment',
   isTextAlignment: true,
   options: ['left', 'center'],
   loadingComponentHeight: '72px',
   meta: true,
};

const CONTENT_CARD_SIZE = {
   type: 'content-card-size',
   name: 'content_card_size',
   title: 'Content card size',
   isTextAlignment: true,
   options: ['s', 'm', 'l'],
   loadingComponentHeight: '72px',
   meta: true,
   go_to_link: {
      text: 'Content card global settings',
      type: 'content_cards',
      segment_type: 'section',
   },
};
const STORIES_SORTING_OPTIONS = getContentSortingOptions('story');
const STORE_SORTING = getContentSortingOptions('store');
const CONTENT_DEFAULT_SORTING = {
   type: 'sort',
   name: 'content_default_sorting',
   title: 'Content default sorting',
   options: getContentSortingOptions('media'),
   meta: true,
};



const LINK_BUTTON_TEXT =  {
   type: 'input',
   name: 'link_button_text',
   title: 'Link button text',
   limit: 50,
   inputProps: {
      type: 'text',
      placeholder: 'Enter a title',
      descriptionPosition: 'right',
   },
   loadingComponentHeight: '66px',
   meta: true,
};
const LINK_TO_SELECT =  {
   type: 'content-link-to-select',
   name: 'link_to',
   title: 'Link to',
   inputProps: {
      placeholder: 'Select',
   },
   loadingComponentHeight: '92px',
   meta: true,
};

const LIBRARY_OPTIONS = {
   type: 'option',
   name: 'options',
   title: 'Options',
   isCheckboxType: true,
   meta: true,
}

const CONTENT_COLLECTIONS_OPTION = {
   type: 'content-collections-option',
   name: 'collections',
   title: 'Collections',
   meta: true,
};

const CONTENT_SHOWCASE_OPTIONS = [
   {
      type: 'option',
      name: 'type',
      title: 'Content type',
      isContentShowcaseTypeOption: true,
      options: [
         { title: 'Stories', value: 'stories_content_showcase' },
         { title: 'Video', value: 'videos_content_showcase' },
         { title: 'Photosets', value: 'photoset_content_showcase' },
         { title: 'Store', value: 'store_content_showcase' },
         { title: 'Recorded streams', value: 'recorded_content_showcase' },
      ],
   },
]

const libraryComponents = {
   video_library: {
      0: [TITLE],
      1: [DESCRIPTION],
      2: [ALIGMENT],
      3: [CONTENT_CARD_SIZE],
      4: [
         {
            ...CONTENT_COLLECTIONS_OPTION,
            options: VIDEO_COLLECTION_OPTIONS,
            contentType: 'video',
         },
      ],
      5: [CONTENT_DEFAULT_SORTING],
      6: [
         {
            ...LIBRARY_OPTIONS,
            options: [
               LIBRARY_OPTIONS_FILTER,
               LIBRARY_OPTIONS_SORTING,
               LIBRARY_OPTIONS_SEARCH,
               LIBRARY_OPTIONS_CONTENT_TAGS,
               LIBRARY_OPTIONS_CONTENT_COUNT,
            ],
         },
      ],
   },
   recorded_livestreams_library: {
      0: [TITLE],
      1: [DESCRIPTION],
      2: [ALIGMENT],
      3: [CONTENT_CARD_SIZE],
      4: [
         {
            ...CONTENT_COLLECTIONS_OPTION,
            options: RECORD_STREAM_COLLECTION_OPTIONS,
            contentType: 'record_stream',
         },
      ],
      5: [CONTENT_DEFAULT_SORTING],
      6: [
         {
            ...LIBRARY_OPTIONS,
            options: [
               LIBRARY_OPTIONS_FILTER,
               LIBRARY_OPTIONS_SEARCH,
               LIBRARY_OPTIONS_CONTENT_COUNT,
            ],
         },
      ],
   },
   photoset_library: {
      0: [TITLE],
      1: [DESCRIPTION],
      2: [ALIGMENT],
      3: [CONTENT_CARD_SIZE],
      4: [
         {
            ...CONTENT_COLLECTIONS_OPTION,
            options: PHOTOSETS_COLLECTION_OPTIONS,
            contentType: 'photoset',
         },
      ],
      5: [CONTENT_DEFAULT_SORTING],
      6: [
         {
            ...LIBRARY_OPTIONS,
            options: [
               LIBRARY_OPTIONS_FILTER,
               LIBRARY_OPTIONS_SORTING,
               LIBRARY_OPTIONS_SEARCH,
               LIBRARY_OPTIONS_CONTENT_TAGS,
               LIBRARY_OPTIONS_CONTENT_COUNT,
            ],
         },
      ],
   },
   store: {
      0: [TITLE],
      1: [DESCRIPTION],
      2: [ALIGMENT],
      3: [CONTENT_CARD_SIZE],
      4: [
         {
            ...CONTENT_COLLECTIONS_OPTION,
            options: STORE_COLLECTION_OPTIONS,
            contentType: 'store',
         },
      ],
      5: [{ ...CONTENT_DEFAULT_SORTING, options: STORE_SORTING }],
      6: [
         {
            ...LIBRARY_OPTIONS,
            options: [
               LIBRARY_OPTIONS_FILTER,
               LIBRARY_OPTIONS_SORTING,
               LIBRARY_OPTIONS_SEARCH,
               LIBRARY_OPTIONS_CONTENT_COUNT,
            ],
         },
      ],
   },
   stories_library: {
      0: [TITLE],
      1: [DESCRIPTION],
      2: [ALIGMENT],
      3: [CONTENT_CARD_SIZE],
      4: [
         {
            ...CONTENT_COLLECTIONS_OPTION,
            options: STORIES_COLLECTION_OPTIONS,
            contentType: 'story',
         },
      ],
      5: [{ ...CONTENT_DEFAULT_SORTING, options: STORIES_SORTING_OPTIONS }],
      6: [
         {
            ...LIBRARY_OPTIONS,
            options: [
               LIBRARY_OPTIONS_FILTER,
               LIBRARY_OPTIONS_SEARCH,
               LIBRARY_OPTIONS_CONTENT_COUNT,
            ],
         },
      ],
   },
}

const showcaseComponents = {
   videos_content_showcase: {
      0: [TITLE],
      1: [DESCRIPTION],
      2: [ALIGMENT],
      3: [CONTENT_CARD_SIZE],
      4: [CONTENT_DEFAULT_SORTING],
      5: CONTENT_SHOWCASE_OPTIONS,
      6: [
         {
            ...CONTENT_COLLECTIONS_OPTION,
            title: 'Choose videos to show',
            options: VIDEO_COLLECTION_OPTIONS,
            contentType: 'video',
         },

      ],
      7: [LINK_BUTTON_TEXT],
      8: [
         {
            ...LINK_TO_SELECT,
            contentLibraryType: 'video_library',
         },
      ],

   },
   recorded_content_showcase: {
      0: [TITLE],
      1: [DESCRIPTION],
      2: [ALIGMENT],
      3: [CONTENT_CARD_SIZE],
      4: [CONTENT_DEFAULT_SORTING],
      5: CONTENT_SHOWCASE_OPTIONS,
      6: [
         {
            ...CONTENT_COLLECTIONS_OPTION,
            title: 'Choose recorded streams to show',
            options: RECORD_STREAM_COLLECTION_OPTIONS,
            contentType: 'record_stream',
         },
      ],
      7: [LINK_BUTTON_TEXT],
      8: [
         {
            ...LINK_TO_SELECT,
            contentLibraryType: 'recorded_livestreams_library',
         },
      ],
   },
   photoset_content_showcase: {
      0: [TITLE],
      1: [DESCRIPTION],
      2: [ALIGMENT],
      3: [CONTENT_CARD_SIZE],
      4: [CONTENT_DEFAULT_SORTING],
      5: CONTENT_SHOWCASE_OPTIONS,
      6: [
         {
            ...CONTENT_COLLECTIONS_OPTION,
            title: 'Choose photosets to show',
            options: PHOTOSETS_COLLECTION_OPTIONS,
            contentType: 'photoset',
         },
      ],
      7: [LINK_BUTTON_TEXT],
      8: [
         {
            ...LINK_TO_SELECT,
            contentLibraryType: 'photoset_library',
         },
      ],
   },
   store_content_showcase: {
      0: [TITLE],
      1: [DESCRIPTION],
      2: [ALIGMENT],
      3: [CONTENT_CARD_SIZE],
      4: [{ ...CONTENT_DEFAULT_SORTING, options: STORE_SORTING }],
      5: CONTENT_SHOWCASE_OPTIONS,
      6: [
         {
            ...CONTENT_COLLECTIONS_OPTION,
            options: STORE_COLLECTION_OPTIONS,
            contentType: 'store',
         },
      ],
      7: [LINK_BUTTON_TEXT],
      8: [
         {
            ...LINK_TO_SELECT,
            contentLibraryType: 'store',
         },
      ],
   },
   stories_content_showcase: {
      0: [TITLE],
      1: [DESCRIPTION],
      2: [ALIGMENT],
      3: [CONTENT_CARD_SIZE],
      4: [{ ...CONTENT_DEFAULT_SORTING, options: STORIES_SORTING_OPTIONS }],
      5: CONTENT_SHOWCASE_OPTIONS,
      6: [
         {
            ...CONTENT_COLLECTIONS_OPTION,
            options: STORIES_COLLECTION_OPTIONS,
            contentType: 'story',
         },
      ],
      7: [LINK_BUTTON_TEXT],
      8: [
         {
            ...LINK_TO_SELECT,
            contentLibraryType: 'stories_library',
         },
      ],
   },
}

export {
   showcaseComponents,
   libraryComponents,
}
